import {Component} from '@angular/core';
import {NavController, NavParams, Platform, Tabs, ViewController} from 'ionic-angular';
import {ServicesPage} from "../services/services";
import {Subscription} from "rxjs";
import {interval} from "rxjs/observable/interval";
import {takeWhile} from "rxjs/operators";
import moment from "moment";
import {HttpClient} from "@angular/common/http";
import {ApiErrorHandlerProvider} from "../../providers/api-error-handler/api-error-handler";

/**
 * Generated class for the ServiceSuccessPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-service-success',
    templateUrl: 'service-success.html',
})
export class ServiceSuccessPage {
    errors: {};
    loading: boolean;

    shop: any;
    barber: any;
    bookingType: number;
    services: any;
    booking: any;
    advancedBooking: any;
    view_counter: number;

    ServiceButton: any;
    timeInSeconds: number;
    ticker: any;
    source: any;
    subscribe: Subscription = new Subscription();
    pause: Subscription = new Subscription();
    resume: Subscription = new Subscription();
    pausedTime: any;
    fromLobby: boolean;
    fromStaffPanel: boolean;
    currencySymbol: string;

    constructor(
        public platform: Platform,
        public navCtrl: NavController,
        public navParams: NavParams,
        private viewCtrl: ViewController,
        private http: HttpClient,
        private apiErrorHandler: ApiErrorHandlerProvider) {
        this.ServiceButton = ServicesPage;
        this.shop = navParams.get('shop');
        this.barber = navParams.get('barber');
        this.services = navParams.get('services');
        this.advancedBooking = navParams.get('advancedBooking');
        this.bookingType = navParams.get('bookingType') ? navParams.get('bookingType') : 1; // 1 = Standard
        this.booking = navParams.get('booking');
        this.fromLobby = navParams.get('fromLobby');
        this.fromStaffPanel = navParams.get('fromLobby');
        this.currencySymbol = navParams.get('currencySymbol');
        this.view_counter = 0;
    }

    ionViewWillEnter() {

        if (this.view_counter > 0) {
            this.view_counter = 0;
            this.navCtrl.popTo(this.navCtrl.getByIndex(0));
        } else {
            this.view_counter++;
        }

        this.viewCtrl.showBackButton(false);

        if (this.booking.estimated_wait_time_in_seconds > 0) {

            // Set the time in seconds
            this.timeInSeconds = this.booking.estimated_wait_time_in_seconds;

            // Start the Countdown timer
            this.timer();

            // Refresh the timer when the user switches between apps
            this.timerRefreshOnDevice();
        }
    }

    ionViewWillLeave() {
        this.pause.unsubscribe();
        this.resume.unsubscribe();
        this.subscribe.unsubscribe();
    }

    timer() {
        this.source = interval(1000).pipe(
            takeWhile(() => {
                if (this.timeInSeconds > 0) {
                    return true
                }
            })
        );

        this.subscribe = this.source
            .subscribe(() => {
                this.timeInSeconds = this.timeInSeconds - 1;
                this.ticker = this.getSecondsAsDigitalClock(this.timeInSeconds);
            });
    }

    timerRefreshOnDevice() {
        this.platform.ready().then(() => {
            this.pause = this.platform.pause.subscribe(() => {
                this.pausedTime = moment();
            });

            this.resume = this.platform.resume.subscribe(() => {
                if (this.timeInSeconds > 0) {
                    this.loading = true;
                    this.getBookingTimer().then((booking: any) => {
                        if (booking && booking > 0) {
                            this.timeInSeconds = booking;
                            let duration = moment.duration(moment().diff(this.pausedTime)).asSeconds();
                            let seconds = booking - duration;
                            this.ticker = this.getSecondsAsDigitalClock(seconds);
                            this.loading = false;
                        }
                    });
                }
            });
        });
    }

    getBookingTimer() {
        return new Promise((resolve, reject) => {
            this.http.get(`/booking/${this.booking.id}/timer`)
                .subscribe((booking: any) => {
                    return resolve(booking);
                }, error => {
                    this.errors = this.apiErrorHandler.handleError(error);
                    return reject(this.errors);
                }, () => {
                });

        });
    }

    getSecondsAsDigitalClock(seconds: number) {
        if (seconds >= 172800) {
            return moment(moment()).add(seconds, 'seconds').format('Do MMMM YYYY');
        }

        return moment.utc(seconds * 1000).format('HH:mm:ss');
    }

    openMyBookings() {

        // Pop to the shop page
        this.navCtrl.popTo(this.navCtrl.getByIndex(1));

        // Select the bookings tab
        let tabBar: Tabs = this.navCtrl.parent;

        if (tabBar) {
            tabBar.select(1);
        }
    }

    makeAnotherBooking() {
        let $this = this;
        this.loading = true;

        if (this.advancedBooking) {
            $this.navCtrl.popTo($this.navCtrl.getByIndex(2));
            return;
        }

        this.getShop().then((shop: any) => {
            shop.users.forEach((user, index) => {
                if (user.id === $this.barber.id) {
                    if (!user.queue_full) {
                        $this.navCtrl.popTo($this.navCtrl.getByIndex(1));
                        return;
                    }

                    if ($this.fromLobby) {
                        $this.navCtrl.popTo($this.navCtrl.getByIndex(2));
                        return;
                    }

                    $this.navCtrl.popTo($this.navCtrl.getByIndex(1));
                }
            })
        });
    }

    getShop() {
        return new Promise((resolve, reject) => {
            this.http.get(`/teams/${this.shop.id}`)
                .subscribe((shop: any) => {
                    return resolve(shop);
                }, error => {
                    this.errors = this.apiErrorHandler.handleError(error);
                    return reject();
                }, () => {

                });
        });
    }


}



// WEBPACK FOOTER //
// ./src/pages/service-success/service-success.ts